"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AllowedCustomOpts = {
  MEETING_SIDEBAR: 'MEETING_SIDEBAR',
  SALES_EXTENSION_SIDEBAR: 'SALES_EXTENSION_SIDEBAR',
  LIVECHAT_SIDEBAR: 'LIVECHAT_SIDEBAR',
  LEADFLOWS_SIDEBAR: 'LEADFLOWS_SIDEBAR',
  FORMS_SIDEBAR: 'FORMS_SIDEBAR',
  DOCUMENTS_SIDEBAR: 'DOCUMENTS_SIDEBAR',
  CRM_EMAIL_SIDEBAR: 'CRM_EMAIL_SIDEBAR',
  MARKETING_FREE_EMAIL_SIDEBAR: 'MARKETING_FREE_EMAIL_SIDEBAR',
  SKIP_SETUP: 'SKIP_SETUP',
  TESTIMONIAL_SIDEBAR: 'TESTIMONIAL_SIDEBAR',
  PARTNER_ID: 'PARTNER_ID'
};
var _default = AllowedCustomOpts;
exports.default = _default;
module.exports = exports.default;